import { observer } from 'mobx-react-lite';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import useRoute, { IRoute } from '@/routes';
import './index.less';
import Sider from './Sider';
import Header from './Header';
import Content from './Content';
import WebviewAuth from '@/pages/webview-auth';
import { useHistory } from 'react-router-dom';
import { Switch, Route, Redirect } from 'react-router-dom';
import ClientUpdate from '@/mobx/modules/clientUpdate';
import { Button, Modal } from '@arco-design/web-react';
import { IconDoubleRight } from '@arco-design/web-react/icon';
import { appStore } from '@/mobx';
import ClientTabs from '@/mobx/modules/tabStore';
import { addTab } from '@/pages/matrix/config';
import _ from 'lodash';

const Layout: React.FC = observer(() => {
  const [route, defaultRoute] = useRoute();
  const authcb = useRef(null);
  console.log(route);

  useEffect(() => {
    if (window.electron) {
      console.log('进入了effect监听===========》');

      window.electron?.ipcRenderer?.webLaunchReady();

      authcb.current = window.electron.ipcRenderer.launchAuth(
        _.debounce((p) => {
          console.log('=========================================>', p);
          const token = p?.token;
          if (token && location.pathname === '/login') {
            location.href = '/login?token=' + token;
          }

          setTimeout(() => {
            appStore.setPlatformId(+p.platform_id);
            // ClientTabs.setActivePath(0);
          }, 500);

          if (p.platform_id && p.id && location.pathname !== '/login') {
            appStore.setPlatformId(+p.platform_id);
            const platformData = appStore.navList.find(
              (item) => item.meta?.platform === +p.platform_id
            );
            addTab(
              {
                auth_data: p.cookie,
                auth_status: 1,
                platform_id: +p.platform_id,
                webview_id: p.webview_id,
                id: +p.id,
              },
              platformData
            );
          }

          // if (!p?.auth_uid) {
          //   addTab(
          //     {
          //       type: 11,
          //       auth_uid: 30,
          //       token:
          //         'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpbmZvIjp7InV1aWQiOiI1NDE0NzA4NTA0NjE3OTM5MDQiLCJzZXNzaW9uX2lkIjoiNzc0ODlhODItNGRhNi00MzRiLWI3YmEtOTZkYzllNTYzNGJjIiwidGVhbV9pZCI6OX0sImV4cCI6MTc3NTYzNzc4NX0.7ew8i74n36kMep5aZBGwK3wShg7QaBmLZANZ9oongYA',
          //     },
          //     {
          //       ...appStore.navList[0],
          //       src: 'https://agents.baidu.com/',
          //       name,
          //       platform: 12,
          //     }
          //   );
          // } else {
          //   console.log('接收到启动参数=================》', p);
          //   addTab(p, { ...appStore.navList[0], src, name, platform });
          // }
        }, 500)
      );
      console.log('authcb=========>', authcb.current);

      // return () => {
      //   if (window.electron && authcb.current) {
      //     setTimeout(() => {
      //       console.log('回调卸载了');
      //       window.electron.ipcRenderer.removeListener(
      //         'launch-auth',
      //         authcb.current
      //       );
      //     }, 3000);
      //   }
      // };
    }
  }, []);

  return (
    <div id="layout" className="layout-box">
      <Sider />
      {/* <Content routes={layoutRoute} defaultRoute={'matrix'} /> */}
      <div className="main-content" style={{ flex: 1 }}>
        {/* 顶部tab */}
        <WebviewAuth />

        <Switch>
          <Route exact path="/">
            <Redirect to={`/${defaultRoute}`} />
          </Route>
          {route.map((item) => (
            <Route
              key={item.key}
              path={`/${item.key}`}
              component={item.component}
            />
          ))}
        </Switch>
      </div>
    </div>
  );
});
export default Layout;
